import { Box, BoxProps } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import React from 'react';

import { forwardRef } from '../../system';

import DisplayNames from './enums';

export type NavBarRightContainerProps = BoxProps & {
  children?: React.ReactNode;
};

const NavBarRightContainer = forwardRef<NavBarRightContainerProps, 'div'>(
  (props: NavBarRightContainerProps, ref): React.ReactElement => {
    const navBarTheme = useMultiStyleConfig('NavBarTheme', props);

    return <Box __css={navBarTheme.navBarRightContainer} ref={ref} {...props} />;
  }
);

NavBarRightContainer.displayName = DisplayNames.NavBarRightContainer;

export default NavBarRightContainer;
